import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgProfileNavIconSecondary from './svgs/ProfileNavIconSecondary.js';
import SvgProfileNavIcon from './svgs/ProfileNavIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var profileNavIcon = (props => useIcon(SvgProfileNavIcon, SvgProfileNavIconSecondary, props));

export { profileNavIcon as default };
